define("shared/modifiers/autoresize", ["exports", "ember-modifier", "@ember/object", "@ember/service", "@ember/debug"], function (_exports, _emberModifier, _object, _service, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"@ember/object",0,"@ember/service",0,"@ember/debug"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  /**
   *
   * @class AutoresizeModifier
   * @extends Modifier
   *
   * AutoresizeModifier vertically auto resizes Textarea based on the input value.
   * Takes the dynamic value of textarea as an argument. It recalulates the height of textarea element based on its content.
   *
   * Positional Parameters:
   * @param {String} value The value passed to the textarea
   *
   * Usage:
   * Will recalculate the height only on input change
   * <Textarea @value=value {{autoresize}} />
   *
   * Will recalculate the height on any value change i.e. adding saved captions or hashtags
   * <Textarea @value=value {{autoresize @value}} />
   *
   */
  let AutoresizeModifier = (_class = class AutoresizeModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "errors", _descriptor, this);
    }

    resize() {
      const {
        element
      } = this;
      element.style.height = 'auto';
      let heightOffset;

      try {
        const style = window.getComputedStyle(element);

        if (style.boxSizing === 'content-box') {
          heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
        } else if (style.boxSizing === 'border-box') {
          heightOffset = element.offsetHeight - element.clientHeight;
        }

        if (isNaN(heightOffset)) {
          heightOffset = 0;
        }

        const requiredHeight = element.scrollHeight + heightOffset;
        element.style.height = "".concat(requiredHeight, "px");
      } catch (error) {
        this.errors.log("Error resizing textarea ".concat(error));
      }
    }

    didInstall() {
      (false && !(this.element.type) && (0, _debug.assert)('Must provide textarea element to autoresize', this.element.type));

      if (this.element.type === 'textarea') {
        this.resize();
        this.element.addEventListener('input', this.resize);
      }
    }

    didUpdateArguments() {
      this.resize();
    }

    willRemove() {
      this.element.removeEventListener('input', this.resize);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "resize", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resize"), _class.prototype)), _class);
  _exports.default = AutoresizeModifier;
});